import React from 'react'

import miscUtils from 'utils/miscUtils'
import PrivilegeBadge from '../privilegeBadge'
import { getCookieValue } from 'utils/cookieStorage'

const MiniProfile = (
    {
        fullName,
        nonCommunityMember,
        setShowMiniProfile,
        ProfileImage,
        determinePrivilege,
        openProfileSlider,
        miniProfileLeftPlacement
    }:
        {
            fullName: string,
            nonCommunityMember?: boolean,
            setShowMiniProfile: (value: boolean) => void,
            ProfileImage: string,
            determinePrivilege: () => string,
            openProfileSlider: () => void,
            miniProfileLeftPlacement?: any
        }
) => {

    const cookieUserID = getCookieValue("user") && getCookieValue("user")['id']

    const [isValidImage, setIsValidImage] = React.useState(true);
    const onImageError = (e: any) => {
        setIsValidImage(false)
    }

    return (
        <div
            className={`mini-profile ${miniProfileLeftPlacement}`}
            style={{
                visibility: nonCommunityMember ? 'hidden' : 'initial'
            }}
            onMouseEnter={() => setShowMiniProfile(true)}
            onMouseLeave={() => setShowMiniProfile(false)}
        >
            <div className="mini-profile-upper">
                {
                    (ProfileImage && isValidImage) ?
                        <img
                            alt='profile image'
                            className="profile-image"
                            src={ProfileImage}
                            onError={onImageError}
                        />
                        :
                        <>
                            {
                                fullName !== null ?
                                    <div
                                        className="no-profile-image"
                                        data-color={miscUtils.getColorInitial(`${fullName}`)}
                                    >
                                        {miscUtils.getNameInitials(fullName)}
                                    </div>
                                    :
                                    <div
                                        className="no-profile-image"
                                        data-color={miscUtils.getColorInitial('No name')}
                                    >
                                        {miscUtils.getNameInitials('No name')}
                                    </div>
                            }
                        </>
                }

                <div className="mini-profile-names">
                    {
                        fullName !== null ?
                            <span className="member-name">{fullName} </span>
                            :
                            <span className="member-name">No name </span>
                    }
                    <PrivilegeBadge privilege={determinePrivilege()} />
                </div>
            </div>
            {
                cookieUserID &&
                <div className='mini-profile-lower'>
                        <button
                            className="view-profile-btn"
                            onClick={() => openProfileSlider()}
                        >
                            View profile
                        </button>
                    </div>
            }

        </div>
    )
}

export default MiniProfile